import axios from "axios";
import API from "../api";
import qs from "querystring";
import cloneDeep from "lodash.clonedeep";
import { renewReservations } from "../utils/module-helper.js";
import moment from "moment";

export const BookingsModule = {
  state: {
    bookings: [], // Full heirarchical bookings list
    reservations: [], // Flat list to be parsed from bookings
    reservedDates: [],

    // TODO: Pull these from API
    bookingStatus: {
      Hold: {
        value: 1
      },
      Booked: {
        value: 2
      },
      Cancelled: {
        value: 3
      },
      NoShow: {
        value: 4
      },
      Expired: {
        value: 5
      }
    },
    // TODO: Pull these from API
    bookingRateTypes: {
      Standard: {
        value: 1
      },
      "Inclusive - Standard": {
        value: 2
      },
      "Inclusive - Room": {
        value: 3
      },
      "Inclusive - Food and Beverage": {
        value: 4
      },
      "Inclusive - Premium": {
        value: 5
      },
      "Daily Flat Rate": {
        value: 6
      }
    },
    isRequesting: false,
    errored: false,
    error: ""
  },
  actions: {
    fetchReservedDates({
      commit
    }, payload) {
      return new Promise((resolve, reject) => {
        let unit_id = payload.unit_id || 0;
        let booking_id = payload.booking_id || 0;

        let request_url = `${API.BASE_URL}${API.RESERVED_DATES}`;
        request_url = `${ request_url }?unit_id=${ unit_id }&booking_id=${ booking_id }`;

        axios
          .get(request_url, API.RequestHeaders())
          .then(response => {
            if (response.status === 200) {
              commit('getReservedDatesSuccess', response.data);
              resolve(response.data);
            }
          })
          .catch(error => {
            commit('getReservedDatesError');
            reject(error.message);
          });
      });
    },
    fetchBookings({
      commit
    }) {
      return new Promise((resolve, reject) => {
        commit("getBookingsRequest");
        axios
          .get(`${API.BASE_URL}${API.BOOKINGS}`, API.RequestHeaders())
          .then(response => {
            if (response.status === 200) {
              commit("getBookingsSuccess", response.data);
              resolve();
            }
          })
          .catch(error => {
            commit("getBookingsError", error.message);
            reject(error.message);
          });
      });
    },
    getBookingsByDate({
      commit
    }, bookings) {
      return new Promise((resolve, reject) => {
        commit("getBookingsByDateRequest");
        const bookingsDate = qs.stringify(bookings);
        axios
          .get(
            `${API.BASE_URL}${API.BOOKINGS}?${bookingsDate}`,
            API.RequestHeaders()
          )
          .then(response => {
            if (response.status === 200) {
              commit("getBookingsByDateSucces", response.data);
              resolve();
            }
          })
          .catch(error => {
            commit("getBookingsByDateError", error.message);
            reject(error.message);
          });
      });
    },
    addBooking({
      commit
    }, _record) {
      let m = moment(_record.starts_at.substr(0, _record.starts_at.indexOf(' ')));

      if (m.fromNow().includes("ago")) {

        let date = moment(new Date()).format("YYYY-MM-DD");
        let m = _record.starts_at.substr(0, _record.starts_at.indexOf(' '));

        if (m === date) {
          return new Promise((resolve, reject) => {
            commit("addBookingRequest");
            return axios
              .post(`${API.BASE_URL}${API.BOOKINGS}`, _record, API.RequestHeaders())
              .then(response => {
                if (response.status == 201) {
                  // since we are not getting the whole object from response use the one from the form
                  commit("addBookingSuccess", response.data.original);
                  resolve();
                }
              })
              .catch(error => {
                commit("addBookingError", error.message);
                reject(error.message);
              });
          });


        } else {
          return console.log("Cannot check in before today: " + date + ".");
        }
      } else {
        return new Promise((resolve, reject) => {
          commit("addBookingRequest");
          return axios
            .post(`${API.BASE_URL}${API.BOOKINGS}`, _record, API.RequestHeaders())
            .then(response => {
              if (response.status == 201) {
                // since we are not getting the whole object from response use the one from the form
                commit("addBookingSuccess", response.data.original);
                resolve();
              }
            })
            .catch(error => {
              commit("addBookingError", error.message);
              reject(error.message);
            });
        });
      }

    },
    updateBooking({
      commit
    }, _record) {
      const {id} = _record;
      delete _record.id;

      return new Promise((resolve, reject) => {
        commit("updateBookingRequest");

        return axios
          .put(
            `${API.BASE_URL}${API.BOOKINGS}/${id}`,
            _record,
            API.RequestHeaders()
          )
          .then(response => {
            if (response.status === 200) {
              commit("updateBookingSuccess", response.data.original);
              resolve();
            }
          })
          .catch(error => {
            commit("updateBookingError", error.message);
            reject(error.message);
          });
      });
    },
    removeBooking({
      commit
    }, _recordId) {
      return new Promise((resolve, reject) => {
        commit("removeBookingRequest");
        return axios
          .delete(
            `${API.BASE_URL}${API.BOOKINGS}/${_recordId}`,
            API.RequestHeaders()
          )
          .then(response => {
            if (response.status === 200) {
              commit("removeBookingSuccess", _recordId);
              resolve();
            }
          })
          .catch(error => {
            commit("removeBookingError", error.message);
            reject(error.message);
          });
      });
    },

    // Reservations
    addReservation({ commit }, record) {
      return new Promise((resolve, reject) => {
        commit("addReservationRequest");
        return axios
          .post(
            `${API.BASE_URL}${API.RESERVATIONS}`,
            qs.stringify(record),
            API.FormRequestHeaders()
          )
          .then(response => {
            if (response.status === 201) {
              commit("addReservationSuccess", response.data.original[0]);
              resolve(response.data.original[0]);
            }
          })
          .catch(error => {
            commit("addReservationError", error.message);
            reject(error.message);
          });
      });
    },

    updateReservation({ commit }, record) {
      const { id } = record;

      return new Promise((resolve, reject) => {
        commit("updateReservationRequest");

        const submitData = {
          booking_id: record.booking_id,
          unit_id: record.unit_id,
          starts_at: record.starts_at,
          ends_at: record.ends_at,
          rate: record.rate,
          rate_type_id: record.rate_type_id,
          confirmation_code: record.confirmation_code,
          vk_door_code: record.vk_door_code
        };

        axios
          .put(
            `${API.BASE_URL}${API.RESERVATIONS}/${id}`,
            qs.stringify(submitData),
            API.FormRequestHeaders()
          )
          .then(response => {
            if (response.status === 200) {
              const data = response.data.original
              commit("updateReservationSuccess", data[0]);
              resolve(data[0]);
            }
          })
          .catch(error => {
            let error_message = '';
            if (error.response && error.response.status === 409) {
              error_message = error.response.data.error;
            } else {
              error_message = error.message
                ? error.message
                : 'Unknown server error';
            }
            commit("updateReservationError", error_message);
            reject(error_message);
          });
      });
    },
    removeReservation({
      commit
    }, reservation) {
      return new Promise((resolve, reject) => {
        const reservationId = reservation.id;

        commit("removeReservationRequest");
        axios
          .delete(
            `${API.BASE_URL}${API.RESERVATIONS}/${reservationId}`,
            API.RequestHeaders()
          )
          .then(response => {
            if (response.status === 200) {
              commit("removeReservationSuccess", reservation);
              resolve();
            }
          })
          .catch(error => {
            commit("removeReservationError", error.message);
            reject(error.message);
          });
      });
    },
    // Guest Reservations
    addGuestToReservation({
      commit
    }, guestReservation) {
      return new Promise((resolve, reject) => {
        commit("addGuestReservationRequest");
        return axios
          .post(`${API.BASE_URL}${API.GUEST_RESERVATIONS}`,
            guestReservation,
            API.RequestHeaders()
          )
          .then(response => {
            if (response.status === 201) {
              commit("addGuestReservationSuccess", response.data.original);
              resolve(response.data.original);
            }
          })
          .catch(error => {
            commit("addGuestReservationError", error.message);
            reject(error.message);
          });
      });
    },
    removeGuestFromReservation({
      commit
    }, reservedGuest) {
      return new Promise((resolve, reject) => {
        commit("removeGuestReservationRequest");
        return axios
          .delete(`${API.BASE_URL}${API.GUEST_RESERVATIONS}/${reservedGuest.id}`,
            API.RequestHeaders()
          )
          .then(response => {
            if (response.status === 200) {
              commit("removeGuestReservationSuccess", reservedGuest);
              resolve();
            }
          })
          .catch(error => {
            commit("removeGuestReservationError", error.message);
            reject(error.message);
          });
      });
    },
    // Guest Bookings
    addGuestToBooking({
      commit
    }, guestBooking) {
      return new Promise((resolve, reject) => {
        commit("addGuestBookingRequest");
        return axios
          .post(`${API.BASE_URL}${API.GUEST_BOOKINGS}`,
            guestBooking,
            API.RequestHeaders()
          )
          .then(response => {
            if (response.status === 201) {
              commit("addGuestBookingSuccess", response.data.original);
              resolve(response.data.original);
            }
          })
          .catch(error => {
            commit("addGuestBookingError", error.message);
            reject(error.message);
          });
      });
    },
    removeGuestFromBooking({
      commit
    }, {guestBooking, newBookingName}) {
      return new Promise((resolve, reject) => {
        commit("removeGuestBookingRequest");
        return axios
          .delete(`${API.BASE_URL}${API.GUEST_BOOKINGS}/${guestBooking.guestBookingId}`,
            API.RequestHeaders()
          )
          .then(response => {
            if (response.status === 200) {
              commit("removeGuestBookingSuccess", {guestBooking, newBookingName});
              resolve();
            }
          })
          .catch(error => {
            commit("removeGuestBookingError", error.message);
            reject(error.message);
          });
      });
    },
    // add or update customer for guest
    addCustomerForGuest({ commit, rootState }, payload) {
      const { stripe_id } = rootState.vendor.vendor
      const guest_id = payload.guest_id || 0;
      const params = {
        stripe_id: stripe_id,
        ...payload
      };

      return new Promise((resolve, reject) => {
        return axios
          .post(`${API.BASE_URL}${API.GUESTS}/${ guest_id }${API.CUSTOMER}`,
            params,
            API.RequestHeaders()
          )
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            if (error.response.status === 400) {
              reject(error.response.data)
            } else {
              reject(error.message);
            }
          });
      });
    }
  },
  mutations: {
    getReservedDatesSuccess(state, payload) {
      state.reservedDates = payload;
    },
    getReservedDatesError(state) {
      state.reservedDates = {};
    },
    getBookingsRequest(state) {
      state.isRequesting = true;
    },
    getBookingsSuccess(state, payload) {
      state.isRequesting = false;
      state.bookings = payload;

      renewReservations(state);
    },
    getBookingsError(state, payload) {
      state.isRequesting = false;
      state.errored = true;
      state.error = payload;
    },
    getBookingsByDateRequest(state) {
      state.isRequesting = true;
    },
    getBookingsByDateSucces(state, payload) {
      state.isRequesting = false;
      state.bookings = payload;
    },
    getBookingsByDateError(state, payload) {
      state.isRequesting = false;
      state.errored = true;
      state.error = payload;
    },
    addBookingRequest(state) {
      state.isRequesting = true;
    },
    addBookingSuccess(state, payload) {
      state.isRequesting = false;
      state.bookings.push(payload);
      renewReservations(state);
    },
    addBookingError(state, payload) {
      state.isRequesting = false;
      state.errored = true;
      state.error = payload;
    },
    updateBookingRequest(state) {
      state.isRequesting = true;
    },
    updateBookingSuccess(state, payload) {
      const currentBooking = state.bookings.find(bookings => bookings.id === payload.id);
      _.extend(currentBooking, payload)

      renewReservations(state);
      state.isRequesting = false;
    },
    updateBookingError(state, payload) {
      state.isRequesting = false;
      state.errored = true;
      state.error = payload;
    },
    removeBookingRequest(state) {
      state.isRequesting = true;
    },
    removeBookingSuccess(state, _recordId) {
      state.isRequesting = false;

      const deletedBooking = state.bookings.find(
        booking => booking.id === _recordId
      );
      const currentIndex = state.bookings.indexOf(deletedBooking);

      state.bookings.splice(currentIndex, 1);

      state.reservations = state.reservations.filter(reservation => reservation.booking_id !== _recordId);
    },
    removeBookingError(state, payload) {
      state.isRequesting = false;
      state.errored = true;
      state.error = payload;
    },

    // Reservations
    addReservationRequest(state) {
      state.isRequesting = true;
    },
    addReservationSuccess(state, payload) {
      state.isRequesting = false;
      state.bookings
        .find(booking => booking.id === payload.booking_id)
        .reservations
        .push(payload);

      renewReservations(state);
    },
    addReservationError(state, payload) {
      state.isRequesting = false;
      state.errored = true;
      state.error = payload;
    },

    updateReservationSuccess(state, data) {
      let booking_index = state.bookings
        .findIndex(booking => booking.id === data.booking_id);

      if(booking_index === -1) {
        return;
      }

      const reservation_index = state.bookings[booking_index].reservations
        .findIndex(reservation => reservation.id === data.id);

      if (reservation_index > -1) {
        state.bookings[booking_index].reservations[reservation_index] = data;
      }

      const index = state.reservations
        .findIndex(reservation => reservation.id === data.id);

      if (index > -1) {
        data.booking_name = state.bookings[booking_index].name;
        data.booking_notes = state.bookings[booking_index].notes;
        state.reservations[index] = data;
      }

      renewReservations(state);
      state.isRequesting = false;
    },

    updateReservationRequest(state) {
      state.isRequesting = true;
    },

    updateReservationError(state, payload) {
      state.isRequesting = false;
      state.errored = true;
      state.error = payload;
    },

    removeReservationRequest(state) {
      state.isRequesting = true;
    },

    removeReservationSuccess(state, reservation) {
      state.isRequesting = false;

      const pastReservations = state.bookings.find(booking => booking.id === reservation.booking_id).reservations;
      _.remove(pastReservations, existingReservation => existingReservation.id === reservation.id)[0];

      renewReservations(state);
    },

    removeReservationError(state, payload) {
      state.isRequesting = false;
      state.errored = true;
      state.error = payload;
    },
    // Guest Reservations
    addGuestReservationRequest(state) {
      state.isRequesting = true;
    },
    addGuestReservationSuccess(state, payload) {
      state.isRequesting = false;
      let reservation = state.reservations.find(reservation => reservation.id === payload.reservation_id)
      reservation['guests'].push(payload);
    },
    addGuestReservationError(state, payload) {
      state.isRequesting = false;
      state.errored = true;
      state.error = payload;
    },
    removeGuestReservationRequest(state) {
      state.isRequesting = true;
    },
    removeGuestReservationSuccess(state, reservedGuest) {
      state.isRequesting = false;
      state.reservations
        .find(reservation => reservation.id === reservedGuest.reservation_id).guests =
        state.reservations
          .find(reservation => reservation.id === reservedGuest.reservation_id).guests
          .filter(guestStay => guestStay.id !== reservedGuest.id);
    },
    removeGuestReservationError(state, payload) {
      state.isRequesting = false;
      state.errored = true;
      state.error = payload;
    },
    // Guest Bookings
    addGuestBookingRequest(state) {
      state.isRequesting = true;
    },
    addGuestBookingSuccess(state, payload) {
      state.isRequesting = false;
      state.bookings.find(booking => booking.id === payload.booking_id).guests.push(payload);
    },
    addGuestBookingError(state, payload) {
      state.isRequesting = false;
      state.errored = true;
      state.error = payload;
    },
    removeGuestBookingRequest(state) {
      state.isRequesting = true;
    },
    removeGuestBookingSuccess(state, {guestBooking, newBookingName}) {
      const affectedBooking = state.bookings.find(booking => booking.id === guestBooking.bookingId);

      affectedBooking.name = newBookingName
      affectedBooking.guests =
        state.bookings
          .find(booking => booking.id === guestBooking.bookingId).guests
          .filter(guestStay => guestStay.id !== guestBooking.guestBookingId);

      renewReservations(state)
      state.isRequesting = false;
    },
    removeGuestBookingError(state, payload) {
      state.isRequesting = false;
      state.errored = true;
      state.error = payload;
    }
  },
  getters: {
    // Bookings
    getBookingStatuses: state => {
      return state.bookingStatus;
    },
    getBookingRateTypes: state => {
      return state.bookingRateTypes;
    },
    getBookings: state => {
      return state.bookings;
    },
    getBooking: (state, getters) => (id) => {
      return getters.getBookings.find(booking => booking.id === id);
    },

    // Reservations
    getReservations: state => {
      return state.reservations;
    },
    getReservationsDeep: state => {
      return cloneDeep(state.reservations);
    },
    getReservedDates: state => {
      return cloneDeep(state.reservedDates);
    }
  }
};
